import { cva } from 'class-variance-authority';

export type RegularButtonSize = 'sm' | 'standard' | 'lg';
type OnlyIconButtonSize = 'icon-sm' | 'icon-standard' | 'icon-lg';

export const iconSizeMap: Record<RegularButtonSize, OnlyIconButtonSize> = {
  sm: 'icon-sm',
  standard: 'icon-standard',
  lg: 'icon-lg',
};

export const buttonLayoutClasses =
  'relative inline-flex cursor-pointer items-center justify-center gap-2 rounded-full text-nowrap antialiased transition-all duration-150 ease-out select-none';

export const buttonFocusClasses =
  'focus-visible:ring-[3px] focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:outline-none';

export const buttonDisabledClasses =
  'disabled:pointer-events-none data-disabled:pointer-events-none';

export const buttonSizeConfig = {
  sm: 'h-[32px] px-4 py-2 text-[14px] leading-[16px]',
  standard: 'h-[40px] px-5 py-3 text-[14px] leading-[16px]',
  lg: 'h-[48px] px-8 py-4 text-[16px] leading-[16px]',
  'icon-sm': 'h-[32px] w-[32px]',
  'icon-standard': 'h-[40px] w-[40px]',
  'icon-lg': 'h-[48px] w-[48px]',
} as const;

export const buttonSpinnerSizeConfig = {
  sm: 'h-[16px] w-[16px]',
  standard: 'h-[24px] w-[24px]',
  lg: 'h-[32px] w-[32px]',
  'icon-sm': 'h-[16px] w-[16px]',
  'icon-standard': 'h-[24px] w-[24px]',
  'icon-lg': 'h-[32px] w-[32px]',
} as const;

export const buttonIconVariants = cva('', {
  variants: {
    size: {
      sm: 'size-[16px]',
      standard: 'size-[16px]',
      lg: 'size-[16px]',
      'icon-sm': 'size-[16px]',
      'icon-standard': 'size-[24px]',
      'icon-lg': 'size-[32px]',
    },
  },
});
